import { render, staticRenderFns } from "./SideMenuStudent.vue?vue&type=template&id=80854168&scoped=true"
import script from "./SideMenuStudent.vue?vue&type=script&lang=js"
export * from "./SideMenuStudent.vue?vue&type=script&lang=js"
import style0 from "./SideMenuStudent.vue?vue&type=style&index=0&id=80854168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80854168",
  null
  
)

export default component.exports